import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles/index';
import {Button, Card, CardContent, FormControl, Input, InputLabel, Typography} from '@material-ui/core';
import classNames from 'classnames';
import {Link} from 'react-router-dom';
import * as Actions from 'auth/store/actions/index';
import _ from 'lodash';
import {FuseAnimate} from '@fuse';
import Formsy from 'formsy-react';
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

const styles = theme => ({
    root: {
        // background    : "url('/assets/images/backgrounds/dark-material-bg.jpg') no-repeat",
        // backgroundSize: 'cover'
    },
    card: {
        width   : '100%',
        maxWidth: 384
    }
});

class NewChangePassword extends Component {
    state = {
        name           : '',
        oldPassword    : '',
        password       : '',
        passwordConfirm: ''
    };

    handleChange = (event) => {
        this.props.resetPasswordChanged()
        this.setState(_.set({...this.state}, event.target.name, event.target.type === 'checkbox' ? event.target.checked : event.target.value));
    };

    canBeSubmitted()
    {
        const {oldPassword, password, passwordConfirm} = this.state;
        return (
            oldPassword.length > 0 &&
            password.length > 0 &&
            password.length > 3 &&
            password === passwordConfirm
        );
    }

    handleSubmit = () => {
        // console.log(this.state)
        this.props.checkPassword(this.state.oldPassword, this.props.auth.user.data.auth_id, this.state.password)
        this.setState({
            oldPassword: '',
            password: '',
            passwordConfirm: ''
        })
    }

    render()
    {
        const {classes, passwordChanged, incorrectPasswordEntered} = this.props;
        const {oldPassword, password, passwordConfirm} = this.state;
        // console.log(this.props)

        const incorrectBlock = (prop) => {
            if (prop) {
                return <Typography className="mt-16 mb-32">INCORRECT PASSWORD ENTERED</Typography>
            }
            return null
        }

        const successBlock = (prop) => {
            // console.log(prop)
            if (prop) {
                return <Typography  className="mt-16 mb-32">PASSWORD CHANGED</Typography>
            }
            return <Typography  className="mt-16 mb-32">RESET YOUR PASSWORD</Typography>
        }
        return (
            <div className={classNames(classes.root, "flex flex-col flex-auto flex-no-shrink items-center justify-center p-32")}>

                <div className="flex flex-col items-center justify-center w-full">
                    {successBlock(passwordChanged)}
                    {incorrectBlock(incorrectPasswordEntered)}
                    <FuseAnimate animation="transition.expandIn">

                        <Card className={classes.card}>

                            <CardContent className="flex flex-col items-center justify-center p-32">

                                <Formsy name="resetForm" noValidate className="flex flex-col justify-center w-full">

                                    <FormControl className="mb-16" fullWidth required>
                                        <InputLabel>Old Password</InputLabel>
                                        <Input
                                            type="password"
                                            name="oldPassword"
                                            value={oldPassword}
                                            onChange={this.handleChange}
                                        />
                                    </FormControl>

                                    <FormControl className="mb-16" fullWidth required>
                                        <InputLabel>Password</InputLabel>
                                        <Input
                                            type="password"
                                            name="password"
                                            value={password}
                                            onChange={this.handleChange}
                                        />
                                    </FormControl>

                                    <FormControl className="mb-16" fullWidth required>
                                        <InputLabel>Password (Confirm)</InputLabel>
                                        <Input
                                            type="password"
                                            name="passwordConfirm"
                                            value={passwordConfirm}
                                            onChange={this.handleChange}
                                        />
                                    </FormControl>

                                    <Button
                                        variant="contained"
                                        color="primary"
                                        className="w-224 mx-auto mt-16"
                                        aria-label="Reset"
                                        disabled={!this.canBeSubmitted()}
                                        onClick={() => this.handleSubmit()}
                                    >
                                        RESET MY PASSWORD
                                    </Button>

                                </Formsy>

                                {/* <div className="flex flex-col items-center justify-center pt-32 pb-24">
                                    <Link className="font-medium" to="/pages/auth/login">Go back to login</Link>
                                </div> */}

                            </CardContent>
                        </Card>
                    </FuseAnimate>
                </div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        // changePassword: Actions.changePassword,
        checkPassword: Actions.checkPassword,
        resetPasswordChanged: Actions.resetPasswordChanged,
    }, dispatch);
}

function mapStateToProps({ auth }) {
    return {
        auth,
        // passwordValid: auth.passwordchange.passwordValid,
        passwordChanged: auth.passwordchange.passwordChanged,
        resetPasswordChanged: auth.passwordchange.resetPasswordChanged,
        incorrectPasswordEntered: auth.passwordchange.incorrectPasswordEntered
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(NewChangePassword)));



// WEBPACK FOOTER //
// src/main/content/dashboard/components/NewChangePassword.js